module.exports = __webpack_public_path__ + "static/wtpwa-740df2629f1dc971ff7b0696c91a79f8.webp";